export default __webpack_public_path__ + "static/media/(29).02d68a76.JPG";